// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const useStyles = (theme: any) => ({
  dialog: {
    maxWidth: '540px',
    margin: 'auto',
  },
  dialogContent: {
    padding: '24px 32px',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '500px',
  },
  dialogContentEmpty: {
    minHeight: 'auto',
  },
  dialogHeader: {
    fontSize: '20px',
  },
  dialogText: {
    marginTop: '12px',
    padding: '0px',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  textField: {
    fontWeight: 300,
    letterSpacing: '1.3px',
    maxWidth: '130px',
    fontSize: '14px',
    // 44 px tall, and no stepper arrows: the distance is typed
    '& .MuiOutlinedInput-input': {
      padding: '10.5px 16px',
      MozAppearance: 'textfield',
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
    },
    '& fieldset': {
      borderRadius: 0,
      borderColor: '#EAEAEA',
    },
    // the label sits above the box, so the border needs no gap for it
    '& fieldset legend': {
      maxWidth: '0.01px',
    },
  },
  // the field's small label, lifted just clear of the box so the box's width cannot cut it
  fieldLabel: {
    maxWidth: 'none',
    transform: 'translate(0, -20px) scale(0.75)',
    color: theme.palette.darkGrey,
    '&.Mui-focused': {
      color: theme.palette.darkGrey,
    },
  },
  deliveryDate: {
    color: theme.palette.primary.main,
  },
  expressButtonProgress: {
    color: '#fff',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-8px',
    marginLeft: '-8px',
  },
  dialogActions: {
    marginTop: theme.spacing(2),
    padding: '0px',
  },
  textForm: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '20px',
    marginTop: theme.spacing(4),
  },
  link: {
    color: theme.palette.primary.main,
  },
  checked: {
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  learnMoreButton: {
    marginRight: 'auto',
    color: theme.palette.primary.main,
    padding: '0px',
  },
  helpIcon: {
    color: theme.palette.primary.main,
    marginRight: '8px',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-12px',
    marginLeft: '-12px',
  },
  roadTypesTitle: {
    marginTop: '24px',
  },
  groupRow: {
    alignItems: 'flex-start',
  },
  // the checkbox's own padding, so the group name sits on the box's line
  groupLabel: {
    paddingTop: '9px',
  },
  groupDescription: {
    color: theme.palette.text.secondary,
    fontSize: '13px',
  },
  emptyNote: {
    marginTop: '24px',
    color: theme.palette.text.secondary,
  },
  alert: {
    marginTop: '16px',
  },
});

export default useStyles;
